import { MapColorTheme, MapColorThemeContextProps } from "@app/shared/map-appearance/interfaces";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { ModalLink } from "@app/shared/Modals";
import { QESButton } from "@app/shared/qes-standards/Button";
import { Context, FC, useContext } from "react";

interface MapColorThemeSwatchProps {
  colorThemeContext: Context<MapColorThemeContextProps | null>;
  theme: MapColorTheme;
}

export const MapColorThemeSwatch: FC<MapColorThemeSwatchProps> = ({ colorThemeContext, theme }) => {
  const ctx = useContext(colorThemeContext);
  if (!ctx) throw new Error("MapColorThemeSwatch must be used within a MapColorThemeContextProvider");

  return (
    <div className="map-appearance__swatch-container">
      <div className="map-appearance__swatch">
        {theme.name}
        <div className="map-appearance__swatch-colors">
          {ctx.slotDefinitions.map((slot, idx) => (
            <div
              key={`${theme.uuid}-${idx}`}
              className="map-appearance__color-display"
              style={{
                backgroundColor: theme.colors[slot.key],
              }}
            />
          ))}
        </div>
      </div>
      <QESButton
        onClick={() => {
          ctx.setThemeToEdit(theme);
          ctx.setEditingSlotIndex(null);
        }}
        qesTestId={`map-appearance__swatch-edit-${theme.uuid}`}
        qesType="secondary"
      >
        <div className="map-appearance__edit-button-content">
          <QesIcon iconName={QesIcons.PencilV1} isDecorative />
          Edit
        </div>
      </QESButton>
      <ModalLink
        classNames="qes-button-secondary danger"
        content={{
          body: "Are you sure you want to delete this color theme? This action cannot be undone.",
          cancelButtonText: "Cancel",
          confirmButtonAction: () => ctx.deleteCustomTheme(theme),
          confirmButtonText: "Delete",
          confirmButtonType: "primary-danger",
          title: `Delete ${theme.name}`,
        }}
        hideBodyScroll={true}
        testId={`map-appearance__swatch-delete-${theme.uuid}`}
      >
        Delete
      </ModalLink>
    </div>
  );
};
